import type { DashboardPeriodParams } from '@/lib/dashboard-period'
import { getUserTimeZone } from '@/lib/user-timezone'

/** Параметры запросов к /analytics/* (кроме специальных вроде ticket-handle-timeouts). */
export function periodParamsToAnalyticsQuery(
  p: DashboardPeriodParams,
  extra?: { tz?: string; without_ai_assistant?: boolean },
): Record<string, string | number | boolean> {
  const o: Record<string, string | number | boolean> = {}
  if (p.hours != null) o.hours = p.hours
  if (p.days != null) o.days = p.days
  if (p.date_time_from) o.date_time_from = p.date_time_from
  if (p.date_time_to) o.date_time_to = p.date_time_to
  if (p.project_id) o.project_id = p.project_id
  if (p.exclude_burst) o.exclude_burst = true
  o.tz = extra?.tz ?? getUserTimeZone()
  if (extra?.without_ai_assistant) o.without_ai_assistant = true
  return o
}
